import { ProgramPage } from '@pages/program/program.page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/$programId')({
  component: ProgramPage,
})
